



























import { defineComponent } from '@vue/composition-api'
import { AnswerSummary } from '@/types/questionnaire-answer'

type Props = {
  answerSummaries: (AnswerSummary & { source: string })[]
}

export default defineComponent({
  name: 'AnswerTable',
  props: {
    answerSummaries: {
      type: Array,
      default: () => [],
    },
  },
  setup(_props: Props) {
    return
  },
})
